import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'accredible-base-header',
  templateUrl: './base-header.component.html',
  styleUrls: [`./base-header.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleBaseHeaderComponent {
  handleSkip(): void {
    location.hash = '';
    location.hash = 'main-content';
  }
}
